import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import React from 'react'
interface Props {
  benefit: App.LoyaltyBenefit;
  tier: App.LoyaltyTier;
  title: string;
  icon: React.ReactElement;
}

function AccountDrawerBenefitHighlightItem(props: Props) {
  const { benefit, tier, title, icon } = props

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyTextBlock variant="small" startIcon={icon}>
        {title}
      </BodyTextBlock>
      <LoyaltyTierLabel kind="secondary" tier={tier}>
        {benefit.unlimited && 'Unlimited'}
        {!benefit.unlimited && `${benefit.remaining === 0 ? 'Redeemed' : `${benefit.remaining}x`}`}
      </LoyaltyTierLabel>
    </Group>
  )
}

export default AccountDrawerBenefitHighlightItem
